import { Organization } from "../../../../core/models/entities/Organization";
import { PageQuery } from "../../../../utils/models/pageQuery";
import { QueryChanger } from "../../../shared/hooks/usePageQuery";
import { TableData } from "../../../components/GenericTable/FunctionalList";
import { useNavigate } from "react-router-dom";
import { PrimaryButton } from "../../../components/Buttons/PrimaryButton";
import { organizationColumnsConfig } from "../const/organizationColumnsConfig";
import { CustomerListItemComponent } from "../component/customer-list-item.component";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { nameOf } from "../../../../utils/functions/ReflectionUtil";

export function useFunctionalListOrganizationViewModel(
  isLoading: boolean,
  query: PageQuery,
  queryChanger: QueryChanger,
  lastPage: number,
  organizations?: Organization[]
): TableData<Organization> {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const columnLabelKeys: Record<string, string> = {
    [nameOf<Organization>((x) => x.name)]: "customer",
    [nameOf<Organization>((x) => x.contactPerson)]:
      "orgScreens.columnContactPerson",
    [nameOf<Organization>((x) => x.email)]: "orgScreens.columnEmail",
    [nameOf<Organization>((x) => x.phone)]: "orgScreens.columnPhone",
    [nameOf<Organization>((x) => x.lastOrder)]: "orgScreens.columnLastOrder",
    actions: "action",
  };

  const columns = organizationColumnsConfig.map((column) => ({
    ...column,
    displayValue: columnLabelKeys[column.value]
      ? t(columnLabelKeys[column.value])
      : column.displayValue,
  }));

  function handleRowClick(organization: Organization) {
    navigate(`/customer/${organization.id}/edit`);
  }

  function handleEditRow(organization: Organization) {
    navigate(`/customer/${organization.id}/edit`);
  }

  function handleCreateNewCustomer() {
    navigate(`/customer/add`);
  }

  const center = (
    <PrimaryButton
      key={"create-customer"}
      width={"fit"}
      className="px-4"
      onClick={handleCreateNewCustomer}
    >
      <FontAwesomeIcon icon={faPlus} />
      <span className="flex-1">{t("orgScreens.createNewCustomer")}</span>
    </PrimaryButton>
  );

  return {
    data: organizations,
    query: query,
    lastPage: lastPage,
    isLoading: isLoading,
    tableTitle: t("customers"),
    onSearchQueryChange: queryChanger.handleSearchQueryChange,
    multiSelect: false,
    center: center,
    columns: columns,
    onNewSort: queryChanger.handleSortByField,
    onPageSizeChange: queryChanger.handlePageSizeChange,
    onNewPage: queryChanger.handleNewPage,
    renderRow: (columns, data) => (
      <CustomerListItemComponent
        organization={data}
        columns={columns}
        onEditOrganization={handleEditRow}
      />
    ),
    onRowClick: handleRowClick,
    getKey: (d) => d.id,
  };
}
